import styled from "vue-styled-components";

export const Content = styled.div``;
